<div [ngClass]="classes" >
    {{text}}
    <img *ngIf="imgIcon" [src]="getIconUrl()" class="img-icon">
</div>